import type { SavedReport, SetDefaultSavedReportPayload } from '../interfaces';
import type { ApiResponse } from '@Types';
import { API } from '@Providers';

export default async function ({ _id, is_default }: SetDefaultSavedReportPayload) {
  const endpoint = `/api/shelter/saved-reports/${_id}/default`;

  return API({ endpoint, method: 'post', payload: { is_default } }) as Promise<ApiResponse<SavedReport>>;
}
